import * as idb from 'idb';

// Cache the DB promise to avoid reopening on every operation
let dbPromise;

const getDB = () => {
  if (!dbPromise) {
    dbPromise = idb.openDB('pos360-mini-db', 1, {
      upgrade(database) {
        if (!database.objectStoreNames.contains('redux-persist')) {
          database.createObjectStore('redux-persist');
        }
      },
    });
  }
  return dbPromise;
};

export const deleteDB = (dbName) => {
  const result = idb.deleteDB(dbName);
  // idb.deleteDB returns a Promise only when the DB exists; guard against undefined
  if (result && typeof result.then === 'function') return result;
  return Promise.resolve();
}

// Custom storage for redux-persist using IndexedDB
const indexedDBStorage = {
  getItem: async (key) => {
    try {
      const db = await getDB();
      const value = await db.get('redux-persist', key);
      return value || null;
    } catch (error) {
      console.error('Error getting item from IndexedDB:', error);
      return null;
    }
  },
  setItem: async (key, value) => {
    try {
      const db = await getDB();
      await db.put('redux-persist', value, key);
    } catch (error) {
      console.error('Error setting item in IndexedDB:', error);
      throw error;
    }
  },
  removeItem: async (key) => {
    try {
      const db = await getDB();
      await db.delete('redux-persist', key);
    } catch (error) {
      console.error('Error removing item from IndexedDB:', error);
    }
  },
};

export default indexedDBStorage;
